import React from "react"
import {FieldViewProps} from "../../../render/view";
import DropdownValue from "../components/dropdown-value";


export default function FieldDropdown_View(props: FieldViewProps) {


    const option = props.field._getOption(props.model[props.field.fieldId])

    return <DropdownValue className={props.className} option={option} field={props.field} />

}
